var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 28,
    viewBox: "0 0 220 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_15485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.81094 0L0 2.74117L11.5105 14L0 25.2521L2.81094 28L17.1256 14L2.81094 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6781 0L10.874 2.74117L22.3845 14L10.874 25.2521L13.6781 28L27.9996 14L13.6781 0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_374_15485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5579 1.6084H63.3877V26.3848H67.5579V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9231 1.6084H74.7529V26.3848H78.9231V1.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5795 11.2157L64.8018 15.2344L66.1484 19.1812L77.9262 15.1625L76.5795 11.2157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6487 1.6416H44V5.81181H58.6487V1.6416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4124 3.72656H49.2422V26.3582H53.4124V3.72656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8176 28L81.8096 13.1461L90.984 0L94.3996 2.38298L86.9396 13.0733L96.167 25.5177L92.8176 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4923 11.0283H84.3779V15.1985H94.4923V11.0283Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_374_15485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.769 26.9906L158.138 8.42924L151.878 26.9563L147.725 25.5491L156.003 1.04311L157.836 1.02938L160.149 1.00879L168.901 25.5148L164.769 26.9906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.362 19.3998L158.318 16.3564L155.275 19.3998L158.318 22.4432L161.362 19.3998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.175 28V0H135.561V21.6985L143.4 18.8017L144.924 22.9203L131.175 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.553 27.7735H112.167V0.226562L128.799 9.43176L116.601 22.2614L116.553 22.2133V27.7735ZM116.553 7.6676V15.9461L121.709 10.5232L116.553 7.6676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.91 16.7076L168.908 2.24425L172.855 0.335938L177.866 10.6875L182.809 0.342802L186.769 2.23738L179.864 16.6939L175.91 16.7076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.029 14.1338H175.643V27.6636H180.029V14.1338Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_15485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_374_15485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.1674,
    height: 28,
    fill: "white",
    transform: "translate(44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_374_15485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.6026,
    height: 28,
    fill: "white",
    transform: "translate(112.167)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramPlay);
export default __webpack_public_path__ + "static/media/programPlay.fba742f19319da73a0d3d13ad948e55b.svg";
export { ForwardRef as ReactComponent };